module.exports = __webpack_public_path__ + "static/media/cx.8142eab7.svg";